export default class ScanUpdateRequest {
    assetId = null;
    scanId = null;
    success = false;
    // Browser-captured video duration (HTML5 <video>.duration). 0 means the
    // browser couldn't read it; the server falls back to the worker probe.
    videoLengthSeconds = 0;

    constructor(assetId, scanId, success, videoLengthSeconds = 0){
        this.assetId = assetId;
        this.scanId = scanId;
        this.success = success;
        this.videoLengthSeconds = videoLengthSeconds;
    }
}